import { render } from "./Nav.vue?vue&type=template&id=0b9f75b4&scoped=true"
const script = {}

import "./Nav.vue?vue&type=style&index=0&id=0b9f75b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9f75b4"]])

export default __exports__